import { FC } from 'react';
import styled from 'styled-components';
import TrashIcon from '@mui/icons-material/DeleteOutlined';

import { SkeletonLoader } from '../UI';
import { GrantAccessLevelToDisplayNameMap } from '../../constants';

interface AccessListProps {
  list: any[];
  isLoading?: boolean;
  onAction: (action: NgAction<any>) => void;
}

const StyledAccessList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: ${({ theme }) => theme.fontSize.sm};
`;

const StyledGrantItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px ${({ theme }) => theme.spacing.small};
  border-radius: ${({ theme }) => theme.radius.xSmall};

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey};
  }

  .name {
    font-size: ${({ theme }) => theme.fontSize.sm};
    color: ${({ theme }) => theme.palette.textStrong};
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }
`;

const StyledDeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.darkGrey};
  padding: 2px;
  border-radius: 4px;
  line-height: 0;

  &:hover {
    color: ${({ theme }) => theme.palette.danger};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const AccessList: FC<AccessListProps> = ({ list, isLoading, onAction }) => {
  return (
    <StyledAccessList>
      {(list || []).map((grantItem: any) => (
        <StyledGrantItem key={`${grantItem?.Type}_${grantItem?.ID}`}>
          <span className="name">{grantItem?.Name}</span>

          <div className="actions">
            {grantItem?.Role && (
              <span>{(GrantAccessLevelToDisplayNameMap as Record<string, string>)?.[grantItem.Role] || 'Unknown'}</span>
            )}

            <StyledDeleteButton
              title="Revoke"
              disabled={isLoading}
              onClick={() => onAction({ type: 'REVOKE', payload: grantItem })}
            >
              <TrashIcon style={{ fontSize: 14 }} />
            </StyledDeleteButton>
          </div>
        </StyledGrantItem>
      ))}

      {isLoading && <SkeletonLoader />}
    </StyledAccessList>
  );
};
